import { NavLink, useLocation } from 'react-router-dom';
import { Home, Gift, Clock, User } from 'lucide-react';
import useStore from '@/store/useStore';
import { getSelectedMerchantId, storeRoute } from '@/lib/routes';

export default function BottomNav() {
  const location = useLocation();
  const activeMerchantId = getSelectedMerchantId();
  const navItems = [
    { path: activeMerchantId ? storeRoute(activeMerchantId, 'wallet') : '/store', label: 'Home', icon: Home },
    { path: activeMerchantId ? storeRoute(activeMerchantId, 'rewards') : '/store', label: 'Rewards', icon: Gift },
    { path: activeMerchantId ? storeRoute(activeMerchantId, 'history') : '/store', label: 'History', icon: Clock },
    { path: activeMerchantId ? storeRoute(activeMerchantId, 'profile') : '/store', label: 'Profile', icon: User },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 glass-nav bg-white/80 dark:bg-stone-950/80 border-t border-stone-200 dark:border-stone-800" data-testid="bottom-nav">
      <div className="mx-auto max-w-md flex items-center justify-around h-16 px-2">
        {navItems.map(({ path, label, icon: Icon }) => {
          const isActive = location.pathname === path;
          return (
            <NavLink key={path} to={path} data-testid={`nav-${label.toLowerCase()}`} className="flex flex-col items-center justify-center gap-0.5 flex-1 py-1">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center transition-all ${isActive ? 'bg-brand-soft' : ''}`}>
                <Icon className={`w-5 h-5 transition-colors ${isActive ? 'text-brand' : 'text-stone-400'}`} strokeWidth={isActive ? 2.5 : 1.5} />
              </div>
              <span className={`text-[10px] font-semibold transition-colors ${isActive ? 'text-brand' : 'text-stone-400'}`}>{label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
